var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mod-demo-echarts" },
    [
      _c("el-alert", {
        attrs: { title: "提示：", type: "warning", closable: false },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (description) {
              return _c("div", {}, [
                _c("p", { staticClass: "el-alert__description" }, [
                  _vm._v(
                    "1. 此Demo2只提供ECharts官方使用文档，入门部署和体验功能。具体使用请参考：http://echarts.baidu.com/index.html"
                  ),
                ]),
              ])
            },
          },
        ]),
      }),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-card", [
                _c("div", { ref: "echartDemo", staticClass: "chart-box" }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("chart1-item"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }